import { Capitalize, ToString } from './utils';
import { isEmpty } from 'lodash';

export function GetAddress(address?: Address.IAddress | null) {
  if (!address || isEmpty(address)) {
    return '';
  }

  return `${Capitalize(ToString(address.streetName))} ${Capitalize(ToString(address.streetNumber))} ${Capitalize(
    ToString(address.building)
  )} ${Capitalize(ToString(address.apartment))}`;
}
